import { render } from "./ModalLoading.vue?vue&type=template&id=6d6b9a34"
import script from "./ModalLoading.vue?vue&type=script&lang=js"
export * from "./ModalLoading.vue?vue&type=script&lang=js"

import "./ModalLoading.vue?vue&type=style&index=0&id=6d6b9a34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__